import { Sprite } from "pixi.js"

/** A small render-only stretch around the soles; never changes entity coordinates. */
export class IdleBreathing {
    private target?: Sprite
    private base?: { x: number; y: number; scaleX: number; scaleY: number }
    private strength = 0
    private lastTime?: number
    private readonly phase: number
    private readonly period: number

    constructor(seed: string) {
        let hash = 0
        for (let i = 0; i < seed.length; i++) hash = (Math.imul(hash, 31) + seed.charCodeAt(i)) >>> 0
        this.phase = (hash % 1000) / 1000 * Math.PI * 2
        this.period = 3500 + (hash % 1500)
    }

    update(target: Sprite | undefined, ground: { x: number; y: number }, now: number): void {
        if (target !== this.target) {
            this.reset()
            this.target = target
            if (target) this.base = { x: target.x, y: target.y, scaleX: target.scale.x, scaleY: target.scale.y }
        }
        if (!target || !this.base) return
        const elapsed = this.lastTime === undefined ? 0 : Math.max(0, Math.min(100, now - this.lastTime))
        this.lastTime = now
        this.strength = Math.min(1, this.strength + elapsed / 400)
        const breath = Math.sin(now / this.period * Math.PI * 2 + this.phase) * this.strength
        const sx = 1 - breath * 0.002
        const sy = 1 + breath * 0.008
        target.scale.set(this.base.scaleX * sx, this.base.scaleY * sy)
        target.position.set(ground.x + (this.base.x - ground.x) * sx,
            ground.y + (this.base.y - ground.y) * sy)
    }

    reset(): void {
        if (this.target && this.base) {
            this.target.position.set(this.base.x, this.base.y)
            this.target.scale.set(this.base.scaleX, this.base.scaleY)
        }
        this.target = undefined
        this.base = undefined
        this.strength = 0
        this.lastTime = undefined
    }
}
